import { render, staticRenderFns } from "./PeerView.vue?vue&type=template&id=93ab5bea"
import script from "./PeerView.vue?vue&type=script&lang=js"
export * from "./PeerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports